import React from 'react';
import ReactDOM from 'react-dom';
import angular from 'angular';
import GroupCall from './GroupCall';
import { components as Core } from '../../../core';
import { streamToParticipantMapper } from '../../helpers';
import service from '../../../../providers/video/common/services/active-stream-service';
import { actions as callActions } from '../../../call';
export default angular
    .module('doxy.call-mobile.group-call-angular', [service])
    .component('groupCall', {
    //group-call
    template: `<div></div>`,
    bindings: {
        streams: '<',
        publisher: '<',
        activeStreamId: '<',
        pinnedStreamId: '<',
        hasVideo: '<',
        hasAudio: '<',
        avatar: '<',
    },
    controller: function ($element, $ngRedux) {
        const render = async () => {
            ReactDOM.render(React.createElement(Core.withProviders(GroupCall), {}), $element[0]);
        };
        this.$onInit = render;
        this.$onDestroy = () => ReactDOM.unmountComponentAtNode($element[0]);
        this.$onChanges = (changes) => {
            if (changes.pinnedStreamId) {
                $ngRedux.dispatch(callActions.setPinnedStreamId(this.pinnedStreamId));
            }
            if (changes.activeStreamId) {
                $ngRedux.dispatch(callActions.setActiveStreamId(this.activeStreamId));
            }
            if (changes.hasAudio) {
                $ngRedux.dispatch(callActions.setSelfParticipant({ hasAudio: this.hasAudio }));
            }
            if (changes.hasVideo) {
                $ngRedux.dispatch(callActions.setSelfParticipant({
                    hasVideo: this.hasVideo,
                }));
            }
            if (changes.avatar) {
                $ngRedux.dispatch(callActions.setSelfParticipant({ avatar: this.avatar }));
            }
            if (changes.publisher && changes.publisher.currentValue) {
                $ngRedux.dispatch(callActions.setSelfParticipant({
                    videoElementPromise: changes.publisher.currentValue.videoElementPromise,
                }));
            }
            if (changes.streams) {
                $ngRedux.dispatch(callActions.setParticipants(streamToParticipantMapper(this.streams)));
            }
        };
    },
}).name;
